import { Component } from '@angular/core';
import { TranslateModule } from '@client/app/modules/translate.module';

@Component({
    selector: 'seo-missing-subheadlines',
    templateUrl: './missing-subheadlines.component.html',
    standalone: true,
    imports: [TranslateModule],
})
export class SeoMissingSubheadlinesComponent {
}
